var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{class:_vm.className,attrs:{"src":require('../../assets/'+_vm.imageName),"contain":_vm.contain,"position":_vm.position}})}
var staticRenderFns = []

export { render, staticRenderFns }